/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AttendanceStatRow
 */
export interface AttendanceStatRow {
    /**
     * 
     * @type {string}
     * @memberof AttendanceStatRow
     */
    status: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AttendanceStatRow
     */
    count: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof AttendanceStatRow
     */
    percentage: number;
}

/**
 * Check if a given object implements the AttendanceStatRow interface.
 */
export function instanceOfAttendanceStatRow(value: object): value is AttendanceStatRow {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    return true;
}

export function AttendanceStatRowFromJSON(json: any): AttendanceStatRow {
    return AttendanceStatRowFromJSONTyped(json, false);
}

export function AttendanceStatRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceStatRow {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
        'percentage': json['percentage'],
    };
}

export function AttendanceStatRowToJSON(json: any): AttendanceStatRow {
    return AttendanceStatRowToJSONTyped(json, false);
}

export function AttendanceStatRowToJSONTyped(value?: AttendanceStatRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
        'percentage': value['percentage'],
    };
}

